// extracted by mini-css-extract-plugin
module.exports = {"link":"Item_link__2xqHg","cell":"Item_cell__8CDr5","latestReadingWidgets":"Item_latestReadingWidgets__2E97s"};